import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'

import classes from './ChartContainer.module.scss'

const ChartContainer = ({ title, children, divider = '', className = '', isEmpty = false }) => {
  return (
    <div className={clsx(classes.root, className)}>
      {divider && (
        <div
          className={clsx(classes.divider, {
            [classes.dividerTop]: divider === 'top',
            [classes.dividerRight]: divider === 'right',
            [classes.dividerBottom]: divider === 'bottom',
            [classes.dividerLeft]: divider === 'left',
          })}
        />
      )}
      <div className={clsx({ [classes.emptyContainer]: isEmpty })}>
        <Typography
          component="h3"
          variant="heading-sm"
          className={clsx(classes.title, {
            [classes.isEmpty]: isEmpty,
          })}
        >
          {title}
        </Typography>
        {isEmpty && (
          <Typography component="span" className={classes.emptyMessage}>
            - Not enough reviews
          </Typography>
        )}
      </div>
      {children}
    </div>
  )
}

export default ChartContainer
